<template>
    <div class="basicInfo">
        <h1 class="title">基本信息</h1>
        <div class="info-container">
            <div class="userInfo">
                <!-- <p style="margin-top:40px;">登录账号<span>{{loginName.replace(/^(.{4})(?:\d+)(.{4})$/,"$1******$2")}}</span></p> -->
                <p style="margin-top:40px;">
                    登录账号
                    <span>{{loginName}}</span>
                </p>
                <p style="margin-top:17px;">
                    姓名
                    <span>{{realName}}</span>
                </p>
            </div>
            <el-form ref="info_form" :model="info_form" label-width="90px" class="basicInfo" :rules="info_rules">
                <el-form-item label="照片" style="position:relative;" prop="head">
                    <div class="head-sculpture">
                        <el-upload
                            class="upload-head avatar-uploader"
                            :action="uploadPhoto()"
                            :show-file-list="false"
                            :on-success="handleImgSuccess"
                            :before-upload="beforeImgUpload"
                        >
                            <img slot="trigger" v-if="imageUrl" :src="imageUrl" class="upload-img" />
                            <img slot="trigger" v-if="headUrl&&!imageUrl" :src="getImgSrc2(headUrl)" class="upload-img" />
                            <!-- <img
                slot="trigger"
                v-if="!headUrl&&!imageUrl"
                src="../../assets/head-sculpture.png"
                class="upload-img"
                            >-->
                            <i v-if="!headUrl&&!imageUrl" class="el-icon-plus avatar-uploader-icon"></i>
                            <!-- :src="../../../../assets/head-sculpture.png" -->
                            <!-- <el-button slot="trigger" type="primary">上传头像</el-button> -->
                        </el-upload>
                        <div style class="head-info">
                            <p>照片要求:</p>
                            <p>1.近期正面免冠彩色头像, 头部占照片尺寸的2/3</p>
                            <p>2.白色背景无边框</p>
                            <p>3.人像清晰，层次丰富，神态自然，无明显畸变</p>
                            <p>4.照片尺寸为358px × 441px, 格式为.png或.jpg</p>
                            <p>5.照片大小小于2M</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="性别" class="sex-item" prop="sex">
                    <el-radio-group class="sex" v-model="info_form.sex">
                        <el-radio label="男">
                            <img src="../../assets/sex-male.png" />
                        </el-radio>
                        <el-radio label="女" style="margin-left:30px;">
                            <img src="../../assets/sex-female.png" />
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="部门" prop="myDep" style="margin-bottom:20px;">
                    <el-cascader placeholder="请选择部门" :options="depList" v-model="info_form.myDep" :props="props" :show-all-levels="false"></el-cascader>
                </el-form-item>
                <el-form-item label="岗位" prop="job">
                    <el-select v-model="info_form.job" placeholder="请选择岗位">
                        <el-option v-for="item in jobList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-button type="primary" style="margin-left:80px;background:#1060ab;margin-top:40px;margin-bottom:40px;" @click="saveInfo">下一步</el-button>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        var checkHead = (rule, value, callback) => {
            if (!this.headUrl && !this.imageUrl) {
                this.$message.error("您还没有上传照片")
                callback(new Error(' '))
            } else {
                callback()
            }
        }
        var checkDep = (rule, value, callback) => {
            if (this.info_form.myDep.length <= 0) {
                callback(new Error('请选择您的部门'))
            } else {
                callback()
            }
        }
        return {
            imageUrl: '',
            loginName: '',
            realName: '',
            headUrl: '',
            info_form: {
                head:'',
                sex: '',
                job: '',
                myDep: []
            },
            props: {
                value: 'id',
                label: 'departmentName',
                children: 'childEnterpriseList'
            },
            info_rules: {
                head: [{ required: true, validator: checkHead, trigger: 'blur' }],
                sex: [{ required: true, message: '请选择您的性别', trigger: 'blur' }],
                myDep: [{ required: true, validator: checkDep, trigger: 'blur' }],
                job: [{ required: true, message: '请选择您的岗位', trigger: 'blur' }],
            },
            jobList: [],
            depList: []
        }
    },
    created () {
        if (sessionStorage.token === "" || sessionStorage.token === undefined) {
            this.$message.info("请先登录")
            this.$router.push("/login")
        }
        this.getJobList()
        this.getDepartmentList()
        this.$ajax
            .post(
                "/comuser-service/Account/seeAccount",
                this.postData({
                    id: sessionStorage.userUuid
                })
            )
            .then(res => {
                this.info_form.sex = res.data.tbUser.userSex ? res.data.tbUser.userSex : '男'
                this.info_form.job = res.data.tbAccount.jobType
                this.info_form.myDep = res.data.tbAccount.departmentIds
                this.info_form.job = res.data.tbAccount.jobType
                this.loginName = res.data.tbAccount.loginName
                this.realName = res.data.tbUser.userName
                this.headUrl = res.data.tbUser.photoUrl
                if (this.headUrl === '"null"') {
                    this.headUrl = ''
                }
            })
            console.log(this.info_form,'this.info_form');
            
        
    },
    methods: {
        getDepartmentList () {
            this.$ajax
                .get(
                    "/enterprise-service/Enterprise/getEnterpriseStructure?id=AB294720967E451A8EC0173606CE0650"
                )
                .then(res => {
                    this.depList = res.data.childEnterpriseList
                    // this.depList[0].departmentName = this.depList[0].enterpriseName
                })
        },
        getJobList () {
            this.$ajax
                .post(
                    "/auth-config-service/dict/getKeyAll",
                    this.postData({
                        key: 'postType'
                    })
                )
                .then(res => {
                    this.jobList = res.data
                })
        },
        getImgSrc2 (url) {
            if (url) {
                return this.filesDownload(url)
            } else {
                return
            }
        },
        handleImgSuccess (res, file) {
            this.imageUrl = URL.createObjectURL(file.raw)
            this.headUrl = res.data
        },
        beforeImgUpload (file) {
            const isJPG = file.type === "image/jpeg"
            const isPNG = file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG && !isPNG) {
                this.$message.error("上传图片只能是 JPG或PNG 格式!")
                return false
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!")
                return false
            }
            return true
        },
        saveInfo () {
            // console.log(this.info_form,'this.info_form');
            
            console.log(this.info_form.myDep,'this.info_form.myDep');
            this.$refs["info_form"].validate(valid => {
                if (valid) {
                    let tbAccount = {
                        id: sessionStorage.userUuid,
                        loginName: this.loginName,
                        jobType: this.info_form.job
                    }
                    let tbUser = {
                        userSex: this.info_form.sex,
                        photoUrl: this.headUrl
                    }
                    this.$ajax
                        .post(
                            "/comuser-service/Account/updateUser",
                            this.postData({
                                tbAccount1: JSON.stringify(tbAccount),
                                tbUser1: JSON.stringify(tbUser),
                            })
                        )
                        .then(res => {
                            let data = []
                            data.push({
                                accountId: sessionStorage.userUuid,
                                departmentId: this.info_form.myDep instanceof Array ?this.info_form.myDep[this.info_form.myDep.length - 1]:this.info_form.myDep
                            })
                            this.$ajax
                                .post(
                                    "/enterprise-service/enterpriseUser/updateUsersDep",
                                    this.postData({
                                        data: JSON.stringify(data),
                                        enterpriseId: 'AB294720967E451A8EC0173606CE0650'
                                    })
                                )
                                .then(res => {
                                    this.$message({
                                        message: "个人信息保存成功！",
                                        type: "success"
                                    })
                                    setTimeout(() => {
                                        sessionStorage.hasChecked = 'basic'
                                        this.$router.push('/SaftySetting/SetInfo')
                                    }, 1000)
                                })
                        })
                }
            })
        }
    }
}
</script>
<style lang="scss">
.basicInfo {
  width: 1020px;
  margin: 0 auto;
  // border-left: 1px #dcdcdc solid;
  // border-right: 1px #dcdcdc solid;
  background: rgb(255, 255, 255);
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 167px;
    width: 135px;
    line-height: 167px;
    text-align: center;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .head-info {
    position:absolute;
    font-size:12px;
    top:18px;
    left: 220px;
    p{
      margin: 0;
      line-height: 14px;
      margin-bottom: 10px;
      color:#666666;
    }
  }
  .el-form-item {
    margin: 0;
  }
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
  }
  .info-container {
    margin: 0 40px;
    .userInfo {
      width: 100%;
      height: 130px;
      margin-bottom: 40px;
      border-top: 1px #eeeeee solid;
      border-bottom: 1px #eeeeee solid;
      p {
        color: #666666;
        margin: 0;
        margin-left: 40px;
      }
      span {
        color: #333333;
        margin-left: 20px;
      }
    }
    .basic-info {
      font-size: 16px;
      color: #333333;
      padding-bottom: 10px;
      padding-left: 10px;
      border-bottom: 1px #eeeeee solid;
      margin: 0;
      margin-top: 25px;
      margin-bottom: 60px;
    }
    .other-info {
      font-size: 16px;
      color: #333333;
      padding-bottom: 10px;
      padding-left: 10px;
      border-bottom: 1px #eeeeee solid;
      margin: 0;
      margin-top: 25px;
      margin-bottom: 35px;
    }
    .basicInfo {
      .el-form-item__error {
        top: 40px;
        left: 5px;
      }
      .head-sculpture {
        margin-bottom: 30px;
        margin-left: 40px;
        .el-button {
          padding: 8px 15px;
          font-size: 14px;
          background-color: #eeeeee;
          border-color: #dcdcdc;
          color: #333333;
          position: relative;
          top: -60px;
        }
        .upload-img {
          height: 167px;
          width: 135px;
          // border-radius: 50%;
        }
      }
      .nickname {
        margin-bottom: 40px;
        .el-button {
          padding: 8px 15px;
          font-size: 14px;
          background-color: #eeeeee;
          border-color: #dcdcdc;
          color: #333333;
        }
        .el-input {
          width: 350px;
          margin: 0 5px;
        }
        .el-input__inner {
          height: 32px;
        }
      }
      .sex-item {
        .el-form-item__error {
          top: 48px;
          left: 5px;
        }
      }
      .sex {
        margin-left: 5px;
        margin-bottom: 25px;
        .el-radio__input {
          position: relative;
          top: -15px;
        }
      }
      .birthday {
        margin-left: 5px;
        margin-bottom: 40px;
        .el-date-editor {
          width: 350px;
        }
        .el-input__inner {
          height: 32px;
        }
      }
      .interests {
        margin-left: 5px;
        .el-checkbox-group {
          width: 700px;
          margin-bottom: 35px;
        }
        .el-checkbox__inner {
          display: none;
        }
        .el-checkbox__label {
          padding: 0;
        }
        .el-checkbox.is-bordered {
          padding: 0;
          height: 30px;
          width: 120px;
          text-align: center;
          line-height: 30px;
          margin: 0;
          margin-right: 15px;
        }
        .el-checkbox.is-bordered.is-checked {
          border-color: #409eff;
        }
        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #409eff;
        }
      }
      .email {
        margin-left: 5px;
        margin-bottom: 70px;
        .el-input {
          width: 350px;
          margin: 0 5px;
        }
        .el-input__inner {
          height: 32px;
        }
      }
      .marriage {
        margin-left: 5px;
        margin-bottom: 20px;
      }
      .more-info {
        margin-left: 5px;
        margin-bottom: 20px;
        .el-input {
          width: 350px;
          margin: 0 5px;
        }
        .el-input__inner {
          height: 32px;
        }
      }
    }
    .sex-item {
      .el-form-item__label {
        position: relative;
        top: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/saftySetting/basicInfo.vue